import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Layout } from 'antd';
import { PageContainer, Divider, Link, SkewedEdgeContainer } from 'app/components/common';
const { Footer } = Layout;

import './styles.less';

export const AppFooter = ( props ) => {
    // Construct the classes to use for the root component.
    const classes = classnames(
        'app-footer',
        { [ props.className ]: Boolean( props.className ) },
    );

    return (
        <Footer className={ classes }>
            <SkewedEdgeContainer color="#313131" offset="25px" top ascendClockwise={ false }>
                <div className="footer-content">
                    <PageContainer>
                        <Link newTab className="footer-link" href="https://google.com">
                            Privacy Notice
                        </Link>
                        <Link newTab className="footer-link" href="resources/2020_Policy_Privacy_Shield_enUS.pdf">
                            Privacy Shield Policy
                        </Link>
                        <Link className="footer-link" to="/cookie-policy" >
                            Cookie Policy
                        </Link>
                        <Divider />
                    </PageContainer>
                </div>
            </SkewedEdgeContainer>
        </Footer>
    );
};

AppFooter.propTypes = {
    className: PropTypes.string,
};
